<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <a-form-model
      size="small"
      layout="inline"
      :model="ajaxparams"
      @keyup.native.enter="$refs.myTable.search()"
    >
      <a-form-model-item label="业务经理">
        <a-input
          v-model="ajaxparams.manager_name_like"
          allow-clear
          placeholder="输入业务经理姓名"
          style="width: 180px"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" type="primary" @click="$refs.myTable.search()"
          >搜索</a-button
        >
        <a-button @click="reset" style="margin-left: 8px">重置</a-button>
      </a-form-model-item>
    </a-form-model>
    <MyTable
      class="mt10"
      :apiUrl="bookingOrders_statistics"
      :params="ajaxparams"
      ref="myTable"
      :columns="columns"
      :isSelection="false"
    >
      <template slot="manager_id" slot-scope="item, row, index">
        <div>{{ findManager(row.user && row.user.manager_id ? row.user.manager_id : row.manager_id) }}</div>
      </template>
    </MyTable>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { bookingOrders_statistics as bookingOrdersStatistics } from "@/api/bookingOrders";
import { manager_user_index } from "@/api/manager";
export default {
  name: "BookingOrdersStatistics",
  components: { MyTable },
  data() {
    return {
      bookingOrders_statistics: bookingOrdersStatistics,
      ajaxparams: {
        manager_name_like: "",
      },
      user: [],
      columns: [
        {
          title: "业务经理",
          dataIndex: "user.manager_id",
          key: "manager_id",
          width: 180,
          scopedSlots: { customRender: "manager_id" },
        },
        {
          title: "昨日推送数量",
          dataIndex: "yesterday_count",
          key: "yesterday_count",
          width: 160,
        },
        {
          title: "本月推送数量",
          dataIndex: "month_count",
          key: "month_count",
          width: 160,
        },
      ],
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      const res = await manager_user_index();
      this.user = res || [];
    },
    findManager(manager_id) {
      if (!manager_id) return "";
      const target = this.user.find((obj) => obj.id == manager_id);
      return target ? target.manager_name : "";
    },
    reset() {
      this.ajaxparams = { manager_name_like: "" };
      this.$refs.myTable.search();
    },
  },
};
</script>
<style scoped>
.mt10 {
  margin-top: 10px;
}
</style>